import React from "react";
import PropTypes from "react";
import encrypt  from "../../hooks/crypt";
// import { Redirect } from "react-router";
// import { Redirect } from 'react-router';
// import { browserHistory } from 'react-router';
// import {withRouter} from "react-router-dom";
import { createHashHistory } from 'history'; 
// import { Redirect } from 'react-router-dom'
import pass from "./pass";

class Content extends React.Component {
  static propTypes = {
    myDataProp: PropTypes.any,
    updateStateProp: PropTypes.any,
    onSubmit: PropTypes.any,
    calToken: PropTypes.any,
  };

  render() {
    return (
      <div >
        <p>
          Token:{" "}
          <input
            type="text"
            name="token"
            onChange={this.props.updateStateProp}
          />
        </p>
        <input
          className="btn btn-primary btn-hover-secondary mt-s"
          type="submit"
          value="Verify"
          onClick={this.props.onSubmit}
          />
        {/* <input
          className="btn btn-primary btn-hover-secondary mt-s"
          type="submit"
          value="cal_token"
          onClick={this.props.calToken}
          /> */}
        {/* <p className="show-token">{this.props.myDataProp}</p> */}
      </div>
    );
  }
}

//   export default Content;

class VerifyForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: "Token"};
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.calToken = this.calToken.bind(this);
    // this.myhis=this.props.history;
    
  }
  calToken(event)
  {
    var token_list=new Array();
    var pass_list=new Array()
    for(let passwd of token_list)
    {
      let pass_hash=encrypt(passwd);
      pass_list.push(pass_hash);
    }
    // console.log(pass_list);
    event.preventDefault()
  }
  handleChange(event) {
    
    this.setState({ value: event.target.value });
  }
  handleSubmit(event) {
    var flag=false;
    // console.log(this.state.value);
    let value_en= encrypt(this.state.value);
      flag=pass.includes(value_en);
    // for (let passwd of pass)
    // }
    if (flag) {
      sessionStorage.setItem("islog", flag);
      // alert("Your Token is right!");
      // redirect
      // return <Redirect to='/registration'></Redirect>
      const history = createHashHistory(); 
      history.push("/registration");
      //   : "/";
      // // 登陆成功之后的跳转
      // this.myhis.push("/icsi2022/registration");

    } else {
      alert("Your Token is Wrong! Please check!");
    }
    event.preventDefault();
  }

  render() {
    var value = this.state.value;
    return (
      <div>
        <Content
          myDataProp={value}
          updateStateProp={this.handleChange}
          onSubmit={this.handleSubmit}
          calToken={this.calToken}
        ></Content>
      </div>
    );
  }
}


export default VerifyForm;
